import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { KeybindingDisableService } from '../../services/keybinding-disable.service';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  public message: string = '';
  public icon: string = 'assets/icons/delete.svg';

  private data: any = null;

  constructor(private keybindingDisableService: KeybindingDisableService,
              @Inject(DIALOG_DATA) private dialogData: { message: string, data?: any, icon?: string },
              private dialogRef: DialogRef) {
  }

  ngOnInit(): void {
    if (this.dialogData.data) {
      this.data = this.dialogData.data;
    }

    if (this.dialogData.icon) {
      this.icon = this.dialogData.icon;
    }

    this.message = this.dialogData.message;
    this.keybindingDisableService.disabled = true;
  }

  ngOnDestroy(): void {
    this.keybindingDisableService.disabled = false;
  }

  public onConfirm(): void {
    this.dialogRef.close(this.data);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
